import React, { useContext, useState } from "react";

import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Skeleton from "@material-ui/lab/Skeleton";

import { makeStyles } from "@material-ui/core/styles";
import { green, grey } from '@material-ui/core/colors';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import AttendantCoachingModal from "./AttendantCoachingModal";
// Extraido pra utils/attendantCoaching.js (projeto "layout novo"
// 2026-10-21) pra ser reaproveitado tambem pela versao Nova do
// Dashboard sem duplicar a logica - mesmas funcoes, mesmo resultado.
import { formatTime, getDicas, computeTeamAverages } from "../../utils/attendantCoaching";

const useStyles = makeStyles(theme => ({
    on: {
        color: green[600],
        fontSize: '20px'
    },
    off: {
        color: grey[600],
        fontSize: '20px'
    },
}));

export default function TableAttendantsStatus(props) {
    const { loading, attendants } = props;
    const classes = useStyles();
    const teamAvg = computeTeamAverages(attendants || []);
    const { user } = useContext(AuthContext);
    const isAdmin = user?.profile === "admin";
    const [coachingAttendant, setCoachingAttendant] = useState(null);

    function renderList() {
        return attendants.map((a, k) => (
            <TableRow key={k}>
                <TableCell>{a.name}</TableCell>
                <TableCell align="center">{a.rating}</TableCell>
                <TableCell align="center">{a.countRating}</TableCell>
                <TableCell align="center">{a.tickets}</TableCell>
                <TableCell align="center">{formatTime(a.avgWaitTime)}</TableCell>
                <TableCell align="center">{formatTime(a.avgSupportTime)}</TableCell>
                <TableCell align="center">{formatTime(a.avgTotalTime)}</TableCell>
                <TableCell align="center">
                    {a.online ?
                        <Tooltip title="Online">
                            <CheckCircleIcon className={classes.on} />
                        </Tooltip>
                        :
                        <Tooltip title="Offline">
                            <ErrorIcon className={classes.off} />
                        </Tooltip>
                    }
                </TableCell>
                <TableCell>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {getDicas(a, teamAvg).map((d, i) => (
                            <Chip key={i} label={d.text} size="small" color={d.color === "default" ? undefined : d.color} variant="outlined" />
                        ))}
                    </Box>
                </TableCell>
                {isAdmin && (
                    <TableCell align="center">
                        <Tooltip title="Coaching de IA">
                            <IconButton size="small" onClick={() => setCoachingAttendant(a)}>
                                <EmojiObjectsIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </TableCell>
                )}
            </TableRow>
        ))
    }

    return (!loading ?
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{i18n.t("dashboard.users.name")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.assessments.score")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.assessments.ratedCalls")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.assessments.totalCalls")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.cards.averageWaitingTime")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.cards.averageServiceTime")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.cards.averageTotalTime")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.cards.status")}</TableCell>
                        <TableCell>Dicas</TableCell>
                        {isAdmin && <TableCell align="center">Coaching IA</TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {renderList()}
                </TableBody>
            </Table>
            {isAdmin && (
                <AttendantCoachingModal
                    open={!!coachingAttendant}
                    onClose={() => setCoachingAttendant(null)}
                    attendant={coachingAttendant}
                />
            )}
        </TableContainer>
        : <Skeleton variant="rect" height={150} />
    )
}
